module.exports = __webpack_public_path__ + "img/search.3ded9706.svg";